// @ts-nocheck

import { createSelector } from 'reselect';

import { selectSearchQuery } from '../../selectors/search/searchPrimary.selector';

const selectIsSearching = createSelector([selectSearchQuery], (query) => query?.length > 1);

const selectMobileSportsRouteViewProps = createSelector([selectIsSearching], (isSearching) => ({
  isSearching,
}));

export default selectMobileSportsRouteViewProps;
